// src/components/Auth/LoginScreen.jsx
import React, { useState } from "react";
import { signInWithEmailAndPassword } from "firebase/auth";
import { auth } from "../../firebase/config";
import "../../styles/LoginScreen.css";

export default function LoginScreen() {
  const [mode, setMode] = useState("email");
  const [error, setError] = useState("");

  const handleLogin = async (e) => {
    e.preventDefault();
    setError("");

    let email, password;

    if (mode === "email") {
      email = e.target.email.value.trim();
    } else {
      const phone = e.target.phone.value.trim();
      email = `${phone}@nukkad.app`;
    }

    password = e.target.password.value.trim();

    try {
      await signInWithEmailAndPassword(auth, email, password);
      window.location.href = "/";
    } catch (err) {
      setError(err.message);
    }
  };

  return (
    <div className="login-wrapper">
      <div className="login-card">
        <img
          src="/assets/nukkad-logo.png"
          alt="Nukkad Logo"
          className="login-logo"
        />

        <h2 className="login-title">Welcome Back</h2>

        <div className="login-switch">
          <button
            className={mode === "email" ? "active" : ""}
            onClick={() => setMode("email")}
          >
            Email Login
          </button>
          <button
            className={mode === "phone" ? "active" : ""}
            onClick={() => setMode("phone")}
          >
            Phone Login
          </button>
        </div>

        {/* 🔥 Autofill Disabled Here */}
        <form 
          onSubmit={handleLogin} 
          className="login-form"
          autoComplete="off"
        >
          {mode === "email" ? (
            <>
              <label>Email</label>
              <input
                type="email"
                name="email"
                required
                placeholder="Enter email"
                autoComplete="new-email"
              />
            </>
          ) : (
            <>
              <label>Phone Number</label>
              <input
                type="text"
                name="phone"
                required
                placeholder="Enter phone number"
                autoComplete="new-phone"
              />
            </>
          )}

          <label>Password</label>
          <input
            name="password"
            type="password"
            required
            placeholder="Enter password"
            autoComplete="new-password"
          />

          <button type="submit" className="login-btn">
            Login
          </button>

          {error && <p className="error">{error}</p>}
        </form>

        <p className="signup-link">
          Have an invite?{" "}
          <a href="/signup">Create Account</a>
        </p>
      </div>
    </div>
  );
}
